import { render, staticRenderFns } from "./TraxAccountRoleEditData.vue?vue&type=template&id=1d81c68c"
import script from "./TraxAccountRoleEditData.vue?vue&type=script&lang=js"
export * from "./TraxAccountRoleEditData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports